import React, { Children } from 'react';
import { motion } from 'framer-motion';
const containerVariants = {
  hidden: {
    opacity: 0
  },
  visible: {
    opacity: 1,
    transition: {
      staggerChildren: 0.15
    }
  }
};
const itemVariants = {
  hidden: {
    opacity: 0,
    y: 20
  },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.6,
      ease: 'easeOut'
    }
  }
};
export function OpeningHook() {
  return <section className="py-16 md:py-[80px] px-4" data-id="element-171">
      <motion.div className="max-w-[800px] mx-auto" variants={containerVariants} initial="hidden" whileInView="visible" viewport={{
      once: true,
      margin: '-100px'
    }} data-id="element-172">
        {/* Section Label */}
        <motion.div variants={itemVariants} className="mb-6" data-id="element-173">
          <div className="mb-3 flex items-center gap-2 font-heading text-[9px] font-bold tracking-[3px] text-gold uppercase" data-id="element-174">
            <span className="inline-block h-[2px] w-5 bg-gold" data-id="element-175"></span>
            La Verdad Incómoda
          </div>
        </motion.div>

        {/* Big dramatic opener */}
        <motion.div variants={itemVariants} className="mb-10" data-id="element-176">
          <div className="rounded-r-lg border border-border border-l-[3px] border-l-gold bg-surface-dark px-[22px] py-[20px]" data-id="element-177">
            <p className="text-[20px] md:text-[26px] font-black italic leading-[1.3] text-gold" data-id="element-178">
              "Hablemos con una honestidad que duela."
            </p>
          </div>
        </motion.div>

        {/* Pain points as scannable list */}
        <motion.div variants={itemVariants} className="mb-10" data-id="element-179">
          <div className="overflow-hidden rounded-lg border border-border bg-surface" data-id="element-180">
            <div className="flex items-center gap-2 border-b border-border bg-surface-light px-[18px] py-3" data-id="element-181">
              <div className="h-1.5 w-1.5 rounded-full bg-gold" data-id="element-182"></div>
              <div className="font-heading text-[9px] font-bold tracking-[2px] text-gold uppercase" data-id="element-183">
                ¿Te suena familiar?
              </div>
            </div>
            <div className="px-[18px] py-[18px]" data-id="element-184">
              <ul className="flex flex-col" data-id="element-185">
                <li className="flex items-start gap-2.5 border-b border-border py-2.5 text-[13px] leading-[1.6] text-[#bbb]" data-id="element-186">
                  <span className="mt-[2px] shrink-0 font-bold text-gold" data-id="element-187">
                    →
                  </span>
                  Te levantas cada mañana esperando que hoy todo "haga clic"
                </li>
                <li className="flex items-start gap-2.5 border-b border-border py-2.5 text-[13px] leading-[1.6] text-[#bbb]" data-id="element-188">
                  <span className="mt-[2px] shrink-0 font-bold text-gold" data-id="element-189">
                    →
                  </span>
                  Revisas campañas, analizas gráficos, haces llamadas, sigues el
                  guion del gurú de moda
                </li>
                <li className="flex items-start gap-2.5 border-b border-border py-2.5 text-[13px] leading-[1.6] text-[#bbb]" data-id="element-190">
                  <span className="mt-[2px] shrink-0 font-bold text-gold" data-id="element-191">
                    →
                  </span>
                  Al final del mes,{' '}
                  <strong className="text-white" data-id="element-192">
                    el número en tu cuenta no se mueve
                  </strong>
                </li>
                <li className="flex items-start gap-2.5 border-b border-border py-2.5 text-[13px] leading-[1.6] text-[#bbb]" data-id="element-193">
                  <span className="mt-[2px] shrink-0 font-bold text-gold" data-id="element-194">
                    →
                  </span>
                  Sientes esa presión en el pecho al pasar la tarjeta o cuando
                  llega el alquiler
                </li>
                <li className="flex items-start gap-2.5 py-2.5 text-[13px] leading-[1.6] text-[#bbb]" data-id="element-195">
                  <span className="mt-[2px] shrink-0 font-bold text-gold" data-id="element-196">
                    →
                  </span>
                  No es que no seas inteligente — es que{' '}
                  <strong className="text-white" data-id="element-197">la cadena es invisible</strong>
                </li>
              </ul>
            </div>
          </div>
        </motion.div>

        {/* The Crystal Room — dramatic callout */}
        <motion.div variants={itemVariants} className="mb-10" data-id="element-198">
          <div className="rounded-lg border-2 border-gold/20 bg-gold/5 p-6 md:p-8" data-id="element-199">
            <div className="mb-3 font-heading text-[9px] font-bold tracking-[2px] text-gold uppercase" data-id="element-200">
              🔒 La Habitación de Cristal
            </div>
            <p className="text-[14px] leading-[1.8] text-[#ccc] italic" data-id="element-201">
              "Puedes ver la riqueza de otros, puedes oler el éxito, puedes casi
              tocar la libertad... pero cada vez que intentas avanzar,{' '}
              <strong className="text-white not-italic" data-id="element-202">
                chocas contra un muro sólido y transparente.
              </strong>{' '}
              Te golpeas, retrocedes, te sanas las heridas y vuelves a arremeter
              con más fuerza, solo para recibir un impacto más duro."
            </p>
          </div>
        </motion.div>

        {/* The reveal — Punto Ciego */}
        <motion.div variants={itemVariants} data-id="element-203">
          <div className="flex items-center gap-4 rounded-lg border border-border bg-surface px-[22px] py-[20px]" data-id="element-204">
            <div className="flex h-[44px] w-[44px] min-w-[44px] items-center justify-center rounded-full bg-gold text-[18px] font-black text-black" data-id="element-205">
              !
            </div>
            <div data-id="element-206">
              <p className="text-[14px] leading-[1.7] text-[#bbb]" data-id="element-207">
                Ese muro se llama{' '}
                <strong className="text-gold text-[16px]" data-id="element-208">Punto Ciego</strong>.
                Mientras no lo extraigas de tu sistema operativo, ninguna
                estrategia te hará libre. Si el freno de mano está puesto,{' '}
                <strong className="text-white" data-id="element-209">
                  solo vas a quemar el motor.
                </strong>
              </p>
            </div>
          </div>
        </motion.div>
      </motion.div>
    </section>;
}